import { createContext, useContext } from 'react';
import { useProjectData } from '../hooks/useProjectData';
import { useAuth } from './AuthContext';

const ProjectDataContext = createContext();

export const ProjectDataProvider = ({ children, isVault }) => {
  const { user } = useAuth();
  const data = useProjectData(user, isVault);

  return <ProjectDataContext.Provider value={data}>{children}</ProjectDataContext.Provider>;
};

export const useProject = () => {
  const context = useContext(ProjectDataContext);
  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectDataProvider');
  }
  return context;
};
